// extracted by mini-css-extract-plugin
module.exports = {"input":"copy-link-block_input__2nLPD","button":"copy-link-block_button__2o-po"};